// extracted by mini-css-extract-plugin
export default {"BulletedListItem":"z4Tkv","behavior--appLink":"X8AVi","icon":"GYZXa","title":"yS7C4","text":"_72OAu","innerAppLink":"_6Doee","skeleton-progress":"uQQaH"};